import Vue from "vue";
import {
  ValidationProvider,
  ValidationObserver,
  extend,
  localize,
} from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import es from "vee-validate/dist/locale/es.json";
import {
  variables,
  apiEndPointMail,
  apiEndPointPhone,
  apiEndPointMailExStudent,
  apiEndPointPhoneExStudent,
} from "../clase-formulario/includes/data";
import axios from "axios";

Object.keys(rules).forEach((rule) => {
  extend(rule, rules[rule]);
});

localize("es", es);

Vue.component("ValidationProvider", ValidationProvider);
Vue.component("ValidationObserver", ValidationObserver);

let validLead = false;
let messageLead = "";
let validExStudent = false;
let messageExStudent = "";

/* Validación estudiante nuevo */
extend("uniqueEmailLead", {
  validate: async () => {
    let formDataEmail = new FormData();
    formDataEmail.append("email", variables.family.email);
    await axios.post(apiEndPointMail, formDataEmail).then((response) => {
      messageLead = response.data.data.message[0];
      validLead = response.data.data.valid;
    });
    return !validLead;
  },
  message: () => {
    return messageLead;
  },
});

extend("uniquePhoneLead", {
  validate: async () => {
    let formDataPhone = new FormData();
    formDataPhone.append("phone", variables.family.phone);
    await axios.post(apiEndPointPhone, formDataPhone).then((response) => {
      messageLead = response.data.data.message[0];
      validLead = response.data.data.valid;
    });
    return !validLead;
  },
  message: () => {
    return messageLead;
  },
});

/* Validación ex estudiante */
extend("uniqueEmailEx", {
  validate: async () => {
    let formDataEmail = new FormData();
    formDataEmail.append("email", variables.exstudent.email);
    await axios
      .post(apiEndPointMailExStudent, formDataEmail)
      .then((response) => {
        messageExStudent = response.data.data.message[0];
        validExStudent = response.data.data.valid;
      });
    return !validExStudent;
  },
  message: () => {
    return messageExStudent;
  },
});

extend("uniquePhoneEx", {
  validate: async () => {
    let formDataPhone = new FormData();
    formDataPhone.append("phone", variables.exstudent.phone);
    await axios
      .post(apiEndPointPhoneExStudent, formDataPhone)
      .then((response) => {
        messageExStudent = response.data.data.message[0];
        validExStudent = response.data.data.valid;
      });
    return !validExStudent;
  },
  message: () => {
    return messageExStudent;
  },
});
